var UniaGAVConstants = UniaGAVConstants || {};

UniaGAVConstants = {
  LocalStorageKeys: {
    AdminMerkliste: "uniaGavAdminMerkliste",
    AdminSearch: "uniaGavAdminSearch",
    Authentication: "userToken",
  },
  UniaContractEditionState: {
    0: "Undefined",
    1: "EDIT",
    2: "ForPublish",
    3: "AKTUALISIERT",
    4: "SUPERSEDED",
    5: "DEACTIVATED",
  },
  EditionEditModes: {
    editDetails: "editDetails",
    editCantons: "editCantons",
    editNogaBranches: "editNogaBranches",
    editLinks: "editLinks",
    editAttatchments: "editAttatchments",
    editTenants: "editTenants",
    editCriterions: "editCriterions",
    minimalWageCalculator: "minimalWageCalculator",
    minimumWageConfigurator: "minimumWageConfigurator",
    professionContribution: "professionContribution",
    minimumWageConfigurations: "minimumWageConfigurations",
    editLanguages: "editLanguages",
  },
  VersionEditModes: {
    editTenants: "editTenants",
    versionDetails: "versionDetails",
  },
  MinimumWageNavigation: {
    inputScreen: {
      value: "Eingabemaske",
      name: "inputScreen",
      symbol: "fa-keyboard",
      route: "eingabemaske",
    },
    inputGrouping: {
      value: "Eingabegruppierung",
      name: "inputGrouping",
      symbol: "fa-object-ungroup",
      route: "eingabegruppierung",
    },
    variables: {
      value: "Formeln & Variablen",
      name: "variables",
      symbol: "fa-superscript",
      route: "formelnvariabeln",
    },
    calculationRules: {
      value: "Berechnungsregeln",
      name: "calculationRules",
      symbol: "fa-ruler-combined",
      route: "berechnungsregeln",
    },
    //zuschlagsConfiguration: {
    //  value: "Zuschlagsrechner Konfiguration",
    //  name: "zuschlagsConfiguration",
    //  symbol: "fa-calculator",
    //  route: "zuschlagskonfiguration"
    //},
    //holidays: {
    //  value: "Feiertage",
    //  name: "holidays",
    //  symbol: "fa-birthday-cake",
    //  route: "feiertage"
    //},
    validation: {
      value: "Validierung",
      name: "validation",
      symbol: "fa-exclamation-triangle",
      route: "validierung",
    },
    textBlocks: {
      value: "Textblöcke",
      name: "textBlocks",
      symbol: "fa-align-justify",
      route: "textbloecke",
    },
    alternativeText: {
      value: "Alternativtext",
      name: "alternativeText",
      symbol: "fa-font",
      route: "alternativetexte",
    },
    comments: {
      value: "Kommentare",
      name: "comments",
      symbol: "fa-comment-dots",
      route: "kommentare",
    },
    settings: {
      value: "Einstellungen",
      name: "settings",
      symbol: "fa-cog",
      route: "einstellungen",
    },
  },
  UserRoles: {
    Administrator: "VertragsmanagementAdministration",
    Sachbearbeiter: "VertragsmanagementVerwaltung",
    Benutzer: "VertragsmanagementEinsicht",
  },
  tempDataTenantName: "tempdata.ch",
};

export { UniaGAVConstants };
